"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getProp = _interopRequireDefault(require("../utils/get-prop"));
var _image = _interopRequireDefault(require("./image"));
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates a `gallery` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.sys.contentType
 * @param {object} entry.sys.contentType.sys
 * @param {string} entry.sys.contentType.sys.id
 * @param {object} entry.fields
 * @param {array<object>} entry.fields.images - An array of Contentful assets
 * @param {string} entry.fields.mobileColumns - Number of columns to use on mobile
 * @param {string} entry.fields.tabletColumns - Number of columns to use on tablet
 * @param {string} entry.fields.desktopColumns - Number of columns to use on desktop
 * @returns {object} - `gallery` content model
 */

var createGallery = function createGallery(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var introDoc = (0, _getProp["default"])(fields, 'intro');
  var outroDoc = (0, _getProp["default"])(fields, 'outro');
  var intro = introDoc ? (0, _processRichText["default"])({
    document: introDoc,
    factories: _standard["default"]
  }) : null;
  var outro = outroDoc ? (0, _processRichText["default"])({
    document: outroDoc,
    factories: _standard["default"]
  }) : null;
  return {
    id: (0, _getProp["default"])(sys, 'id'),
    site: (0, _getProp["default"])(fields, 'site'),
    title: (0, _getProp["default"])(fields, 'title'),
    intro: intro,
    outro: outro,
    contentType: (0, _getProp["default"])(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    images: (0, _getProp["default"])(fields, 'images') ? fields === null || fields === void 0 ? void 0 : fields.images.map(function (image) {
      return (0, _image["default"])(image);
    }) : null,
    mobileColumns: (0, _getProp["default"])(fields, 'mobileColumns'),
    tabletColumns: (0, _getProp["default"])(fields, 'tabletColumns'),
    desktopColumns: (0, _getProp["default"])(fields, 'desktopColumns')
  };
};
var _default = createGallery;
exports["default"] = _default;